module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Thin.c574340.woff";